/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import styled from "styled-components";

import { BaseUser } from "src/classes/user";

interface Props {
  user: BaseUser;
}

export const JoinedMessage = ({ user }: Props) => {
  return (
    <>
      {user.snapshot.registeredWithUrbit ? (
        <JoinedText>
          {user.readableDateJoined} {/* Urbit users shouldn't show invitedBy */}
        </JoinedText>
      ) : (
        <JoinedText>
          {user.readableDateJoined}
          {/* on an invite from VHT user should show VHT as invitedBy */}
          {/* <Username hoverable={invitedByProfile !== activeProfile} user={invitedByProfile} /> */}
        </JoinedText>
      )}
      {user.snapshot.badges?.includes("urbit") && (
        <JoinedText>
          Signed up with <b>Urbit</b>
        </JoinedText>
      )}
    </>
  );
};

const JoinedText = styled.div`
  margin-top: 10px;
  /* Mono/Silver Chalice */
  color: #aeaeae;
  font-family: "Inter";
  font-size: 13px;
`;
